import { createAsyncThunk } from '@reduxjs/toolkit'
import { getLoggedInUser } from 'api/user'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let loadingPromise: Promise<any> | undefined
let generation = 0

export function invalidateUserLoad(): void {
    generation += 1
    loadingPromise = undefined
}

const loadUser = createAsyncThunk('user/loadUser', async () => {
    const requestGeneration = generation

    /**
     * If a loading promise already exists, return it instead
     * of initiating another API request.
     */
    if (!loadingPromise) {
        const request = getLoggedInUser()?.finally(() => {
            if (loadingPromise === request) loadingPromise = undefined
        })

        loadingPromise = request
    }

    const assertCurrentSession = () => {
        if (requestGeneration !== generation) {
            throw new DOMException('Session ended', 'AbortError')
        }
    }

    try {
        const user = await loadingPromise

        // Old requests must not restore authentication or reject a new login.
        assertCurrentSession()

        return user
    } catch (error) {
        assertCurrentSession()

        throw error
    }
})

export default loadUser
